import React, { useState } from 'react';
import { Box, Container, createStyles, Dialog, Grid, IconButton, makeStyles, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Theme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { Add } from '@material-ui/icons';
import useCommonApi from '../../api/useCommonApi';
import ReactLoading from 'react-loading';
import CloseIcon from '@material-ui/icons/Close';
import AgregarContacto from './AgregarContacto';
import Help, { IHelp } from '../help/Help';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { useContactosDistribuidor } from '../../contextos/contactosDistribuidorContext';
import { useContactosDistribuidorDestino } from '../../contextos/contactosDistribuidorDestinoContext';

interface Props {
    abierto: boolean
    confirmar: () => void
    cerrar: () => void
    maxWidth?: 'lg' | 'md' | 'sm' | 'xl'
    distribuidor: any
    setContacto: (direccion: any) => void
    cliente: any
    usuario: any
    ayuda?: IHelp, 
    esOrigen: boolean
}



const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        container: {
            backgroundColor: "#fff",
        },
        text: {
            backgroundColor: "#fff",
            textTransform: "uppercase"
        },
        div_direccion: {
            fontSize: '16px',
            width: "100%",
            textAlign: "center",
            paddingBottom: "20px"
        },
        contactoInfo: {
            fontSize: '18px',
            width: "100%",
            fontWeight: 600,
            textAlign: "center"
        },
        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        actions: {
            textAlign: "center",
            width: "100%",
            display: "block",
            padding: "30px 0px"
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            minWidth: 650,
        },
    }),
);


const RecoleccionContacto = ({ abierto, cerrar, confirmar, maxWidth, distribuidor, setContacto, cliente, usuario, ayuda, esOrigen }: Props) => {
    const classes = useStyles();
    const apiSource = useCommonApi();
    const [showLoading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');
    const [contactoSeleccionado, setContactoSelecionado] = useState({ id: 0, nombre: "", puesto: "", departamento: "", telefono: "", correo: "", clienteDistribuidorID: 0 });
    const {contactosDistribuidor, setContactosDistribuidor} = useContactosDistribuidor();
    const {contactosDistribuidorDestino, setContactosDistribuidorDestino} = useContactosDistribuidorDestino();
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [agregaContacto, setNuevoContacto] = useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedValue(event.target.value);
        let id = event.target.value.split('-');
        let contactoSeleccionado = esOrigen ? contactosDistribuidor.contactos.filter(m => m.clienteDistribuidorContactoID === Number(id[0]))
        : contactosDistribuidorDestino.contactos.filter(m => m.clienteDistribuidorContactoID === Number(id[0]));
        if (contactoSeleccionado.length) {

            setContactoSelecionado({
                id: contactoSeleccionado[0].clienteDistribuidorContactoID,
                nombre: contactoSeleccionado[0].nombreClienteDistribuidorContacto ? contactoSeleccionado[0].nombreClienteDistribuidorContacto : contactoSeleccionado[0].nombre,
                puesto: contactoSeleccionado[0].puesto,
                departamento: contactoSeleccionado[0].departamento,
                telefono: contactoSeleccionado[0].telefono,
                correo: contactoSeleccionado[0].correo,
                clienteDistribuidorID: contactoSeleccionado[0].clienteDistribuidorID
            });
        }
    };

    React.useEffect(() => {
        let id = distribuidor.clienteDistribuidorID ? distribuidor.clienteDistribuidorID : distribuidor.clienteDistribuidorId;
        if (esOrigen && 
            (contactosDistribuidor?.contactos?.length === 0 || contactosDistribuidor?.clienteId !== cliente.id 
                || contactosDistribuidor?.clienteDistribuidorId !== id)) {
                    buscarContactos();
        }
        if (!esOrigen && 
            (contactosDistribuidorDestino?.contactos?.length === 0 || contactosDistribuidorDestino?.clienteId !== cliente.id 
                || contactosDistribuidorDestino?.clienteDistribuidorId !== id)) {
                    buscarContactos();
        }

    }, []);


    const buscarContactos = async () => {
        setLoading(true);
        getContactos().then(result => {
            if (result != null && result.length) {
                let contactosDistribuidor: any[] = [];
                result.forEach(s => {
                    let cont = {
                        rowid: s.clienteDistribuidorID + "-" + s.clienteDistribuidorContactoID,
                        id: s.clienteDistribuidorID,
                        clienteDistribuidorContactoID: s.clienteDistribuidorContactoID,
                        nombre: s.nombreClienteDistribuidorContacto,
                        puesto: s.puesto,
                        departamento: s.departamento,
                        telefono: s.telefono,
                        correo: s.correo,
                        clienteDistribuidorID: s.clienteDistribuidorID
                    };
                    contactosDistribuidor.push(cont);
                });
                let id = distribuidor.clienteDistribuidorID ? distribuidor.clienteDistribuidorID : distribuidor.clienteDistribuidorId;
                if(esOrigen)
                    setContactosDistribuidor({clienteId: cliente.id, clienteDistribuidorId: id, contactos: contactosDistribuidor});
                if(!esOrigen)
                    setContactosDistribuidorDestino({clienteId: cliente.id, clienteDistribuidorId: id, contactos: contactosDistribuidor});
                setLoading(false);
            }
            else {
                if(esOrigen)
                    setContactosDistribuidor({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
                if(!esOrigen)
                    setContactosDistribuidor({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
                setLoading(false);
            }
        });
    };

    const getContactos = async () => {
        let id = distribuidor.clienteDistribuidorID ? distribuidor.clienteDistribuidorID : distribuidor.clienteDistribuidorId;
        // { clienteId: cliente.id, nombre: '', puesto: '', departamento: '' }
        const result = await apiSource.obtenerAsync<any>("cliente-distribuidor-contacto/by-distribuidor-client-id", { clienteId: cliente.id, clienteDistribuidorID: id });
        return result;
    };

    const cerrarNuevoContacto = () => {
        setNuevoContacto(false);
        buscarContactos();
    };
    const nuevoContacto = () => {
        setNuevoContacto(true);

    };


    const selectContacto = () => {
        setContacto(contactoSeleccionado);
       
        confirmar();
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    return (<>
        <Dialog open={abierto} maxWidth={maxWidth ? maxWidth : "lg"} fullWidth={true} onClose={cerrar}>
            <DialogTitle id="simple-dialog-title" >
                <Box display="flex" alignItems="center">
                    <Box>
                        <Help comments={traducirMessage(3)} customStyle={{ top: "-40px", right: "-25px" }} />
                    </Box>
                    <Box flexGrow={1} textAlign="center">
                        {/* Contactos */
                        traducirLabel(334)}
                    </Box>
                    <Box>
                        <IconButton onClick={cerrar}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>



            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    <Container maxWidth="xl" className={classes.principal} >

                        <Grid container spacing={3} className={classes.container}>
                            <Grid item xs={12}>
                                <div className={classes.contactoInfo}>


                                </div>
                                <div className={classes.div_direccion}>

                                </div>
                            </Grid>
                        </Grid>
                    </Container>



                    <TableContainer >
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell>
                                        {/* NOMBRE */
                                        traducirLabel(201)}
                                    </TableCell>
                                    <TableCell>
                                        {/* PUESTO / DEPARTAMENTO */
                                        traducirLabel(244)}
                                    </TableCell>
                                    <TableCell>
                                        {/* TELÉFONO / CORREO */
                                        traducirLabel(291)}
                                    </TableCell>
                                    <TableCell> <Button className={classes.icon} color="primary" variant="contained" onClick={() => nuevoContacto()}>
                                        <Add />
                                    </Button></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {showLoading &&
                                    <TableRow key={0}>
                                        <TableCell colSpan={5} component="th" scope="row" style={{ paddingLeft: "50%" }}>
                                            <ReactLoading type="spin" color="#19754e" height={40} width={40} />
                                        </TableCell>
                                    </TableRow>
                                }



                                {(rowsPerPage > 0
                                    ? (esOrigen ? contactosDistribuidor.contactos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : contactosDistribuidorDestino.contactos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
                                    : (esOrigen ? contactosDistribuidor.contactos : contactosDistribuidorDestino.contactos)
                                ).map((row, i) => (
                                    <TableRow key={i}>
                                        <TableCell component="th" scope="row">

                                            <Radio checked={Number(selectedValue) === Number(row.clienteDistribuidorContactoID)}
                                                value={row.clienteDistribuidorContactoID}
                                                onChange={handleChange}
                                                name="radio-button-demo"
                                                inputProps={{ 'aria-label': 'A' }}
                                            />
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.nombre || row.nombreClienteDistribuidorContacto}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.puesto} / {row.departamento}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.telefono} / {row.correo}
                                        </TableCell>
                                        <TableCell component="th" scope="row">

                                        </TableCell>
                                    </TableRow>
                                ))}



                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={esOrigen ? contactosDistribuidor.contactos.length : contactosDistribuidorDestino.contactos.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelRowsPerPage=''
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </TableContainer>

                </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button variant="contained" autoFocus onClick={selectContacto} color="primary"
                    disabled={selectedValue === '' ? true : false}>
                    {/* Continuar */
                    traducirButton(7)}
                </Button>
            </DialogActions>
        </Dialog>


        {
            agregaContacto &&
            <AgregarContacto abierto={agregaContacto} cerrar={cerrarNuevoContacto} confirmar={cerrarNuevoContacto} cliente={cliente} usuario={usuario} distribuidor={distribuidor} setContacto={setContacto} ayuda={ayuda} />
        }

    </>)
};

export default RecoleccionContacto;
